<template>
  <tile class="opc-zmone">
    <zm-alert v-if="licenseAlertDesc && !notification" type="warning" show-icon :closable="false" class="opc-base-alert">
      <p class="opc-base-alert__message" v-html="licenseAlertDesc" @mouseover="licenseAlertMouseoverEventTrack" />
    </zm-alert>
    <zm-alert v-if="notification" type="warning" show-icon :closable="false" class="opc-base-alert">
      <p class="opc-base-alert__message" v-html="notification"  @mouseover="() => $tracking.buyInteraction('banner - product level', trackingPlanName + ' - ' + notification + ' - impression')" />
    </zm-alert>
    <CmrPaywallTip :type="cmrPaywallTipType" />
    <edu-switch-tip v-if="$context.is.edu2esc" :plan="$t('billing.planform.title.zo_edu_sch_cmp')"/>
    <foldable v-model="isExpanded" :title="title" :isRemoveWrapAriaLabelledby="true" :arrow="canExpand" :edit="canExpand">
      <div slot="head" class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img class="opc-zm-base-card__logo" :src="logo" :alt="title" tabindex="-1" />
        </div>
        <div :class="['opc-zm-base-card__head-right', ...headClassForSchool]">
          <h2 :class="['opc-zm-base-card__name', isSchool ? '' : 'text-capitalize']">
            {{ title }}
            <i class="zm-icon-success main-icon" aria-hidden="true"></i>
          </h2>
          <div class="opc-zm-base-card__view-detail-button" v-if="!isCartBuilderAddQty">
            <zm-button class="opc-zm-base-card__link" type="link" @click="handlePlanDetails"
              v-if="isExpanded && showPlanDetail">
              {{ isEdu2Esc? $t('billing.zone.explore_other_plans_edit') : $t('billing.plan_details') }}
            </zm-button>
          </div>
          <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
            {{
              $t('billing.zone.desc1', [
                form.selectedNumber,
                $money(formPlan ? formPlan.amount : 0),
                $t(`billing.common.per_billing_cycle_user.${form.billingCycle}`),
              ])
            }}
          </div>
        </div>
      </div>
      <div class="opc-zmone__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form">
          <zm-form-item>
            <p class="opc-zmone__form-label" slot="label">
              <span v-if="isCartBuilderAddQty">{{ $t('billing.delta.add_user') }}</span>
              <span v-else>{{ $t('billing.zone.select_license') }}</span>
              <zm-tooltip v-if="!isCartBuilderAddQty" v-model="attendeeInfoTooltip" class="item opc-zmone__numbers-users-tooltip"
                aria-label="Learn more about Select the number of users"
                placement="top">
                <i class="zm-icon-info-outline main-icon" role="button"></i>
                <template v-slot:content>
                  {{ $t('billing.zone.attendee_info', [attendee]) }}
                  <zm-button v-if="showIncreaseWithLargeMeetingPromo" @click="addLargeMeetingCard" class="opc-zmone__tip-lm-btn" type="link">{{$t('billing.large_meeting.increase_with')}}</zm-button>
                </template>
              </zm-tooltip>
            </p>
            <template v-if="!isCartBuilderAddQty">
            <license-tip v-if="isNormalCase" :type="form.category" :number="form.selectedNumber" :additionalSpans='additionalSpans'>
              <zm-button v-if="showExploreLink" class="opc-zmone__link" type="link"
                @click="handleExploreOtherPlansClick">{{ $t('billing.zone.explore_other_plans') }}</zm-button>
            </license-tip>
            </template>
            <InputNumberWithPopover class="opc-zmone__quantity-selector" v-model="form.selectedNumber" size="large"
              controls-position="both" :min="minHost" :max="maxHost" @change="updatePlanLicense"
              :decrease-tips="decreaseTips" :increase-tips="increaseTips" :label="`${title} Select the number of users`" />
            <div v-show="showContinueWithLargeMeetingPromotion" class="opc-zmone__lm-promotion" v-html="$t('billing.zoom_one_biz.continue_with_lm')"></div>
            <zm-alert class="reason-tips" v-if="licenseTips" type="info" :closable="false">
              <i class="zm-icon-info" style="color: #9191A4;"></i>
              <p v-html="licenseTips"></p>
            </zm-alert>
          </zm-form-item>
          <zm-form-item v-if='isShowReadyOnlyCycle'>
            <monthly-price :plan='cartMeetingPlan' />
          </zm-form-item>
          <zm-form-item v-else :label="$t('billing.select_billing_cycle')">
            <cycle-radio-group
              v-model="form.billingCycle"
              class="opc-card-radio"
              :plans="currentPlans"
              :action="switchBillingCycle"
              :aria-label="`${title} Billing Cycle`"
            >
              <zm-tooltip v-for="plan in currentPlans" :key="plan.billing_cycle"
                :disabled="!(typeof billingCycleDisabled(plan) === 'string')">
                <div slot="content" v-html="billingCycleDisabled(plan) || ''" />
                <zm-radio :label="plan.billing_cycle" :disabled="!!billingCycleDisabled(plan)"
                  class="opc-zmone__radio">
                  <p class="opc-zmone__radio-title text-capitalize">{{ $t(`billing.billing_cycle.${plan.billing_cycle}`)}}
                  </p>
                  <p v-if="isSchool" class="opc-campus-price-container">
                    <span class="opc-campus-price-container__bill">{{ $money(plan.amount, { forceDiff: true }) }}</span>
                    {{ $t(`billing.common.per_billing_cycle_user.${plan.billing_cycle}`) }}<priceVATTip />
                  </p>
                  <template v-else>
                    <p class="opc-product-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(plan)">
                      <!-- {{ getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true }) }} -->
                      <span v-for="(value, key, index) in getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true })"
                            :key="index"
                            :class="[`opc-product-price-container__${key}`, useSmallSize(value) ? 'opc-product-price-container__small' : '']"
                            :style="value.symbol && value.place === 'end' ? { order: 1 } : {}"
                            aria-hidden="true"
                            >
                        {{ value.symbol ? value.symbol: value }}
                      </span>
                    </p>
                    <p class="opc-zmone__radio-price-unit opc-price-bill-text">
                      <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount)"></span><priceVATTip />
                    </p>
                  </template>
                </zm-radio>
              </zm-tooltip>
            </cycle-radio-group>
          </zm-form-item>
          <preview-payment />
        </zm-form>
        <div v-if="showIncreaseWithLargeMeetingPromo" class="opc-zmone__expand-lm-promo">
          <span>
            {{$t('billing.large_meeting.promo', [attendee])}}
          </span>
          <zm-button @click="addLargeMeetingCard" type="link">{{$t('billing.large_meeting.increase_with')}}</zm-button>
        </div>
        <div class="opc-zm-base-card__main__footer" v-if="couldBeRemovedAsAddonCard">
          <zm-button type="link" ghost @click="removePlanByKey"
            :aria-label="'remove ' + getCategoryName(form.category) + ' plan'">{{ $t('billing.common.remove')
            }}</zm-button>
        </div>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import LicenseTip, { proTextI18nKey } from '../license-tip.vue';
import {
  BILLING_CYCLE,
  limitBillingCycleWithBaseZoneTypes,
  planTypes,
  BASE_PLAN_TYPES, BillingCycleEnum,
  INDUSTRIES,
  BASE_PLAN_SUB_TYPES
} from '@/common/constants';
import plansMixin from '@/plans/mx/plan';
import logo from '@/assets/plans/icon_ZM.svg';
import {
  DEFAULT_MEETING_PLAN_CAPACITY,
  getCategoryNameI18nKey,
  isBizPlusContext,
  isZoomMeetingAsAddonCard,
  ZOOM_MEETING_SUB_TYPES,
  isAutoAddableAndAutoAddPlanSelected,
} from '@/plans/ZOOM_MEETING/common/utils';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { debounce, get, groupBy, throttle } from 'lodash';
import { isEmptyVal } from '@/utils';
import { getTitleNameI18nKey } from '../common/utils';
import saveMixins from '../save-mixins';
import { plansof } from '@/utils/chain';
import { getPlanTypeName } from '@/common/service/parse/parse-product-name';
import { getOnlinePlanName } from '@/common/product';
import _ from "lodash";
import { getPlanUnitWithCycle } from '@/common/product-unit';
// import { PLAN_TYPES_WITH_MULTI_BASE_PLANS } from '@/plans/ROOM_CONNECTOR/common/utils';
import autoCycle from '../mixin/auto-cycle.js';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import { isCartBuilderAddQty } from '@/utils/cart-builder';
import { trackingPlanTypes } from '@/common/constants'
import attachedHealthcareMixin from './healthcare/attached'
import { translateToEn } from '@/plugins/i18n'
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import CmrPaywallTip, { CMR_PAYWALL_TIP_TYPES } from '@/components/cmr-paywall-tip.vue'
import ZoomMeetingDialogUtils from '../dialog/utils';
import { webinarSingleUseAllowed } from '@/common/service/op-switch';
import { getPlanTotalLicense } from '@/common/service/validate';
import MonthlyPrice from '@/components/monthly-price.vue';
import { isFromShoppingCart, isProductCanRemove } from '@/views/config/shopping-cart/persist/plan-remove';
import EduSwitchTip from '@/components/edu-switch-tip.vue';
import { getAssignedLicenseQuantity } from '@/plans/ZOOM_ONE_BUNDLE/utils'
import { getMeetingPlanByCategory } from '@/plans/ZOOM_MEETING/common/utils';
import { validDownSellLicenseForEdu2Esc } from '@/utils/validate-downsell';

export default {
  key: planTypes[planTypes.ZOOM_MEETING],
  components: {
    MonthlyPrice,
    PreviewPayment,
    Foldable,
    Tile,
    InputNumberWithPopover,
    LicenseTip,
    CmrPaywallTip,
    EduSwitchTip
  },
  inject: ['$core'],
  mixins: [attachedHealthcareMixin, plansMixin, saveMixins, autoCycle, discountedMonthPrice],
  data() {
    return {
      logo,
      attendeeInfoTooltip: false,
      isExpanded: true,
      form: {...DEFAULT_MEETING_PLAN_CAPACITY},
      BILLING_CYCLE: BILLING_CYCLE,
      showPlanDetail: false,
      showCategoryDesc: false,
      isInitUpdateForm: false,
      notification: '',
      isBizPlusContext,
      isCartBuilderAddQty,
      canExpand: true,
    };
  },
  created() {
    this.updateForm(true);
    this.$context.$on('notify-meeting', message => {
      this.notification = message;
    });

    ZoomMeetingDialogUtils.install(this.formPlan);
  },
  beforeDestroy() {
    this.$context.$off('notify-meeting');
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['assignInfo','boughtPlans','getSelectedPlans', 'getUserCurrentSubscriptions', 'limitLicenseWithBaseZoneTypes', 'getCurrentBasePlanInfo', 'plansofBizBundle', 'addedTrialToPaidBasePlanList', 'getBoughtMeetingPlans', 'healthcareAvailable', 'isReadOnlyCycleModel']),
    cmrPaywallTipType() {
      switch (this.form.category) {
        case ZOOM_MEETING_SUB_TYPES.PRO:
          return CMR_PAYWALL_TIP_TYPES.PRO
        case ZOOM_MEETING_SUB_TYPES.BIZ:
          return CMR_PAYWALL_TIP_TYPES.BIZ
        default:
          return ''
      }
    },
    isNormalCase() {
      return true;
    },
    additionalSpans() {
      return {};
    },
    showExploreLink() {
      return false;
    },
    showContinueWithLargeMeetingPromotion() {
      return false
    },
    title() {
      return this.$t(this.formPlan?.planNameKey)
    },
    zmAsBasePlan() {
      const key = this.$options.key;
      const planType = planTypes[key];
      return this.getCurrentBasePlanInfo.planType === planType;
    },
    zmIsLastBasePlan() {
      const key = this.$options.key;
      const planType = planTypes[key];
      let baseTypes = plansof(this.getSelectedPlans).type(...BASE_PLAN_TYPES).get().map(x => x.type);
      // 1. is last base plan, e.g. CRC could have more than 1 bas plan
      // 2. zm must as base plan, e.g. Scheduler no need zoom meeting as base plan
      return (baseTypes.length === 1 && baseTypes[0] === planType) && this.zmAsBasePlan
    },
    couldBeRemovedAsAddonCard() {
      if(isFromShoppingCart()) {
        return isProductCanRemove(this.currentPlans[0])
      }
      return isZoomMeetingAsAddonCard() && !this.zmIsLastBasePlan || isBizPlusContext || this.couldBeRemovedInEducation;
    },
    couldBeRemovedInEducation() {
      return this.$context.is.edu && [planTypes.ZOOM_PHONE, planTypes.ZOOM_ROOMS].includes(this.$context.type);
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_MEETING);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    currentPlans() {
      return this.zonePlanGroupByCategory[this.form.category];
    },
    annualPriceM() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount * 12 : 0;
    },
    annalPriceSave() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (this.annualPriceM && annualPlan) {
        return this.annualPriceM - annualPlan.amount;
      }
      return 0;
    },
    saveLabel() {
      return {
        [BILLING_CYCLE.MONTHLY]: '',
        [BILLING_CYCLE.ANNUAL]: this.annalPriceSave > 0
          ? `${this.$money(this.annalPriceSave)} ${this.$t('billing.annual_save')}`
          : '',
      };
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.form.billingCycle,
      );
    },
    totalCoast() {
      if (this.formPlan) {
        return this.formPlan.amount * this.form.selectedNumber;
      }
      return 0;
    },
    exceedBaseLicensePlans() {
      return this.getUserCurrentSubscriptions.filter(item => (
        (item.billing_cycle !== BILLING_CYCLE.ONE_TIME || item?.considerLicenseLimit) &&
        _.includes(this.limitLicenseWithBaseZoneTypes, item.type) &&
        item.cartInfo.selected_number >= this.form.selectedNumber
      ));
    },
    annualAddonPlans() {
      const newLimit = [];
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.concat(newLimit).includes(item.type) &&
        item.billing_cycle === BILLING_CYCLE.ANNUAL
      ));
    },
    maxAddonLicense() {
      return this.exceedBaseLicensePlans.reduce((license, plan) => Math.max(plan.cartInfo.selected_number, license), 0);
    },
    assignedEduLicenseQuantity() {
      const boughtMeetingPlan = getMeetingPlanByCategory(this.boughtPlans, BASE_PLAN_SUB_TYPES.EDUCATION);
      return getAssignedLicenseQuantity([boughtMeetingPlan], this.assignInfo);
    },
    minHost() {
      if(isCartBuilderAddQty) return 1;
      if(isBizPlusContext) return 1;
      const planMin = this.formPlan ? this.formPlan.min : 1;
      if (isAutoAddableAndAutoAddPlanSelected()) {
        return getPlanTotalLicense(this.getBoughtMeetingPlans) || planMin;
      }
      if(this.$context.is.pro2biz) {
        return Math.max(getPlanTotalLicense(this.getBoughtMeetingPlans), planMin);
      }
      if (this.$context.is.add2cart) {
        const { bundleLicenses } = this.plansofBizBundle;
        if (bundleLicenses > 0) {
          return Math.max(Math.min(planMin, this.maxAddonLicense - bundleLicenses), 1);
        }
      }
      if (this.$context.is.edu2esc) {
        if(this.assignedEduLicenseQuantity > planMin){
          return Math.max(planMin, this.assignedEduLicenseQuantity);
        }
      }
      return Math.max(planMin, this.maxAddonLicense);
    },
    maxHost() {
      if(isCartBuilderAddQty) return 9999;
      return this.formPlan ? this.formPlan.max : 99;
    },
    decreaseTips() {
      if(isBizPlusContext) return '';
      const planGroupByType = groupBy(this.exceedBaseLicensePlans, 'type');
      const typeNames = Object.keys(planGroupByType).map(type => {
        const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
      if (this.$context.is.add2cart) {
        const { bundleLicenses } = this.plansofBizBundle;
        if (bundleLicenses > 0) {
          return this.form.selectedNumber <= this.maxAddonLicense - bundleLicenses ? this.$t('billing.licences_limit_tips', [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]) : '';
        }
      }
      if(isAutoAddableAndAutoAddPlanSelected()) return ''
      return this.form.selectedNumber <= this.maxAddonLicense ? this.$t('billing.licences_limit_tips', [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]) : '';
    },
    increaseTips() {
      return ''
    },
    attendee() {
      return get(this.currentPlans, "[0].participants", 0);
    },
    trackingPlanName() {
      if (this.$context.is.edu) {
        return this.$t(getTitleNameI18nKey(this.form?.category));
      }
      else if (this.isSchool) {
        return translateToEn(this.formPlan?.planNameKey);
      }
      else {
        return this.$t(`Zoom One ${this.form?.category}`);
      }
    },
    licenseAlertDesc() {
      return ""
    },
    mx_defLicenseAlertDesc() {
      const configPlan = plansof(this.getSelectedPlans).type(this.$context.type).get(0);
      const meetingPlan = plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).get(0);
      // FREE TRIAL - Pro free trial need to be upgrade with a add plan
      const isCurrentFlowWithBaseFreeTrialPlanUpgraded = (this.addedTrialToPaidBasePlanList || []).length > 0;;
      if(isCurrentFlowWithBaseFreeTrialPlanUpgraded) {
        const originalBaseFreeTrialPlan = this.getBoughtMeetingPlans[0];
        return this.$t("billing.trial.paid_plan_required_when_add_plans", [
          this.$t(getPlanTypeName(this.$context.type)),
          getOnlinePlanName(meetingPlan),
          this.$t('billing.trial.title', [getOnlinePlanName(originalBaseFreeTrialPlan)]),
        ])
      }

      const { licenseDependBasePlanTypeList = [] } = configPlan;
      const isRequired = licenseDependBasePlanTypeList.includes(planTypes.ZOOM_MEETING);
      if (isRequired) {
        if(configPlan.isPPA || [planTypes.ROOM_CONNECTOR, planTypes.ZCM].includes(this.$context.type)) {
          return this.$t("billing.common.consumption_equal_to_base", [
            this.$t(getPlanTypeName(this.$context.type)),
            getOnlinePlanName(meetingPlan),
          ])
        } else {
          const maximumLicensePlan = _.chain(this.getSelectedPlans)
            .filter((p) => _.includes(p?.licenseDependBasePlanTypeList, planTypes.ZOOM_MEETING))
            .orderBy((p) => p?.cartInfo?.selected_number, "desc")
            .get(0)
            .value();

          const typeName = this.$t(getPlanTypeName(maximumLicensePlan?.type || this.$context.type));
          if (webinarSingleUseAllowed && (maximumLicensePlan?.type === planTypes.WEBINAR || this.$context.type === planTypes.WEBINAR)) {
            return this.$t("billing.common.license_equal_to_base_for_webinar", [
              getOnlinePlanName(meetingPlan),
              typeName,
            ])
          }
          return this.$t("billing.common.license_equal_to_base", [
            getOnlinePlanName(meetingPlan),
            typeName,
          ])
        }
      }
      // For some plans like CRC, only need at least 1 license of base plan
      const { dependBasePlanTypeList = [] } = configPlan;
      const isJustBasePlanRequired = dependBasePlanTypeList.includes(planTypes.ZOOM_MEETING);
      if (isJustBasePlanRequired) {
        // if(PLAN_TYPES_WITH_MULTI_BASE_PLANS.includes(this.$context.type)) {
        return this.$t("billing.common.consumption_equal_to_base", [
          this.$t(getPlanTypeName(this.$context.type)),
          getOnlinePlanName(meetingPlan),
        ])
        // }
      }
      return "";
    },
    cartMeetingPlan() {
      return this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
    },
    licenseTips() {
      // if (this.needUnAssignTips && this.isEdu2Esc) {
      //   return this.needUnAssignTips;
      // }
      return '';
    },
    isSchool() {
      return this.form?.category === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP
    },
    isShowReadyOnlyCycle() {
      const hasDisabledCycle = this.currentPlans.find(plan => {
        return this.billingCycleDisabled(plan);
      });
      return hasDisabledCycle && this.isReadOnlyCycleModel;
    },
    headClassForSchool() {
      if (this.isSchool) {
        if (this.isExpanded) {
          return ['opc-zm-base-card__head-right__for_school--expand'];
        } else {
          return ['opc-zm-base-card__head-right__for_school--collapse'];
        }
      }
      return [];
    },
    showIncreaseWithLargeMeetingPromo() {
      return false
    },
    showLargeMeetingPromoInComparison() {
      return false
    },
    isEdu2Esc(){
      return this.$context.is.edu2esc
    },
    needUnAssignTips() {
      const boughtMeetingPlan= getMeetingPlanByCategory(this.boughtPlans, BASE_PLAN_SUB_TYPES.EDUCATION)|| '';
      return validDownSellLicenseForEdu2Esc({ quantity: this.form.selectedNumber } ,boughtMeetingPlan )?.errorMessage;
    },
  },
  mounted() {
    this.$context.$on('collapse-plan-card', this.collapseCard);
  },
  methods: {
    ...mapActions(['switchBillingCycleAction']),
    ...mapMutations(['updateSelectPlan', 'savePersist']),
    // sync shopping cart plan to local form state
    updateForm(isInitUpdateForm = false) {
      const shoppingCartPlan = this.cartMeetingPlan;
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = shoppingCartPlan.cartInfo.selected_number;
      }

      this.isInitUpdateForm = isInitUpdateForm;
    },
    async switchBillingCycle(oldPlan, newPlan) {
      if (!this.formPlan) {
        return;
      }

      const cartInfo = { selected_number: this.form.selectedNumber };
      await this.switchBillingCycleAction([oldPlan?.plan_code, {
        ...newPlan,
        cartInfo,
      }]);

      this.updateForm();
    },
    updatePlanLicense: throttle(function (v) {
      this.$nextTick(async () => {
        if (!this.formPlan) {
          return;
        }

        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }

        this.updateSelectPlan({
          ...this.formPlan,
          cartInfo: {
            selected_number: this.form.selectedNumber,
          },
        });

        this.updateForm();
      });
    }, 200),
    addLargeMeetingCard() {
      this.preventAutoCollapseOnce = true
      this.attendeeInfoTooltip = false
      this.$core.addon(planTypes[planTypes.LARGE_MEETING])
    },
    async handlePlanDetailsClick() {
      if (this.$context.is.edu) {
        let buyInteraction = 'plan details selected',
          buySelection = this.trackingPlanName;
        if (this.$context.type === planTypes.WEBINAR) {
          buyInteraction = `${trackingPlanTypes['WEBINAR']} add-ons`;
          buySelection = `${this.trackingPlanName} - plan details selected`;
        } else if (this.$context.type === planTypes.ZOOM_PHONE) {
          buyInteraction = `${trackingPlanTypes['ZOOM_PHONE']} add-ons`;
          buySelection = `${this.trackingPlanName} - plan details selected`;
        }
        this.$tracking.buyInteraction(buyInteraction, buySelection);
      } else {
        this.$tracking.buyInteraction('plan details selected', `${this.trackingPlanName}${this.healthcareAvailable ? ` ${INDUSTRIES.HEALTHCARE}` : ''}`);
      }
      if (!this.$context.is.modal) {
        await ZoomMeetingDialogUtils.showPlanDetail({ largeMeetingCb: this.$context.is.basic2pro || this.$context.is.buyNow ? this.addLargeMeetingCard.bind(this) : null, planCategory: this.formPlan.category });
        await this.showFullComparisonDialog();
      } else {
        // for modal iframe swap plan-detail between full-comparsion
        await ZoomMeetingDialogUtils.showPlanDetail({ largeMeetingCb: this.$context.is.basic2pro || this.$context.is.buyNow ? this.addLargeMeetingCard.bind(this) : null, planCategory: this.formPlan.category, showFullComparisonDialogHandler: this.showFullComparisonDialog.bind(this) });
      }

    },
    async handleExploreOtherPlansClick() {
      this.$tracking.buyInteraction('explore other plans', `${this.trackingPlanName} - explore other plans`);
      if (this.healthcareAvailable) {
        const trackingPlanName = translateToEn(getTitleNameI18nKey(this.form?.category))
        const bannerText = translateToEn(proTextI18nKey)
        this.$tracking.buyInteraction(
          'banner - product level',
          `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${bannerText} - explore other plans`,
        )
      }
      await this.showFullComparisonDialog();
    },
    async showFullComparisonDialog() {
      this.$tracking.buyInteraction('product details', `${this.healthcareAvailable ? `${translateToEn(getTitleNameI18nKey(this.form?.category))} ${INDUSTRIES.HEALTHCARE} ` : ''}full plan comparison - impression`);
      await ZoomMeetingDialogUtils.showComparisonDialog({
        planCategory: this.formPlan.category,
        largeMeetingConfig: {
          pro: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: this.formPlan.category !== ZOOM_MEETING_SUB_TYPES.PRO,
          },
          proPlus: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: this.formPlan.category !== ZOOM_MEETING_SUB_TYPES.PRO_PLUS,
          },
          business: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: this.formPlan.category !== ZOOM_MEETING_SUB_TYPES.BIZ,
          },
          businessPlus: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: this.formPlan.category !== ZOOM_MEETING_SUB_TYPES.BIZ_PLUS,
          },
          school: {
            callback: this.addLargeMeetingCard.bind(this),
            disabled: false,
            display: this.$context.is.basic2pro || this.$context.is.buyNow
          },
          schoolPlus: {
            callback: () => {},
            disabled: true,
            display: this.$context.is.basic2pro || this.$context.is.buyNow
          },
        }
      });
      this.$nextTick(() => this.updateForm());
    },
    getCategoryName(category) {
      return this.$t(getCategoryNameI18nKey(category));
    },
    getBillingCycleDisabledDesc(billingCycle) {
      // from auto-cycle.js
      if (this.autoDisabledCycle(billingCycle)) {
        return this.isAutoDisabledCycleDesc;
      }
      if (this.form.billingCycle === billingCycle && billingCycle === BILLING_CYCLE.ANNUAL) {
        return false;
      }
      const exceedAddonPlans = this.getExceedCycleAddonPlans(BillingCycleEnum[billingCycle]);
      const planGroupByType = groupBy(exceedAddonPlans, 'type');
      const typeNames = Object.keys(planGroupByType).map(type => {
        const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
      if (exceedAddonPlans.length) {
        if(billingCycle === BILLING_CYCLE.MONTHLY){
          return this.$t('billing.planform.monthly_base_disable_tooltip', [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]);
        }else {
          return true;
        }
      }
      return false;
    },
    billingCycleDisabled({ billing_cycle, disabled }) {
      return this.getBillingCycleDisabledDesc(billing_cycle) || disabled === true;
    },
    getPlanUnitWithCycle(cycle) {
      return getPlanUnitWithCycle(cycle);
    },
    getExceedCycleAddonPlans(cycleValue) {
      const newLimit = [];
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.concat(newLimit).includes(item.type) &&
        item.cycleValue > cycleValue
      ));
    },
    collapseCard() {
      this.isExpanded = false;
    },
    licenseAlertMouseoverEventTrack() {
      if (this.$context.is.edu) {
        let buyInteraction = 'banner - product level',
          buySelection = this.trackingPlanName + ' - ' + this.licenseAlertDesc + ' - impression',
          curPlanName = ''
        if (this.$context.type === planTypes.WEBINAR) {
          curPlanName = trackingPlanTypes['WEBINAR'];
          buySelection = `${curPlanName} - ${this.trackingPlanName} - ${this.licenseAlertDesc} - impression`;
        } else if (this.$context.type === planTypes.ZOOM_PHONE) {
          curPlanName = trackingPlanTypes['ZOOM_PHONE'];
          buySelection = `${curPlanName} - ${this.trackingPlanName} - ${this.licenseAlertDesc} - impression`;
        }
        this.$tracking.buyInteraction(buyInteraction, buySelection);
      } else {
        let buySelection = `${this.trackingPlanName} - ${this.licenseAlertDesc} - impression`
        if (this.$context.type === planTypes.ZCM) {
          const curTrackingPlanName = get(trackingPlanTypes, get(planTypes, planTypes.ZCM));
          buySelection = `${curTrackingPlanName} - ${this.licenseAlertDesc} - impression`
        }
        this.$tracking.buyInteraction('banner - product level', buySelection)
      }
    },
    handlePlanDetails(){
      this.isEdu2Esc? this.handleExploreOtherPlansClick() : this.handlePlanDetailsClick()
    },
  },
  watch: {
    attendeeInfoTooltip: {
      handler(val) {
        if (val) {
          if (this.$context.is.edu) {
            let buyInteraction = `${this.trackingPlanName} options`,
              buySelection = 'number of licenses - tooltip';
            if (this.$context.type === planTypes.WEBINAR) {
              buyInteraction = `${trackingPlanTypes['WEBINAR']} add-ons`;
              buySelection = `${this.trackingPlanName} options - ${buySelection}`;
            } else if (this.$context.type === planTypes.ZOOM_PHONE) {
              buyInteraction = `${trackingPlanTypes['ZOOM_PHONE']} add-ons`;
              buySelection = `${this.trackingPlanName} options - ${buySelection}`;
            }
            this.$tracking.buyInteraction(buyInteraction, buySelection);
          } else {
            this.$tracking.buyInteraction(
              `${this.trackingPlanName} options`,
              'number of users - tooltip'
            );
          }
        }
      }
    },
    isExpanded: {
      handler(val) {
        if (this.$context.is.edu) {
          let buyInteraction = 'product details accordion',
            buySelection = `${this.trackingPlanName} - ${val ? 'expand' : 'collapse'}`;
          if (this.$context.type === planTypes.WEBINAR) {
            buyInteraction = `${trackingPlanTypes['WEBINAR']} add-ons`;
            buySelection = `${this.trackingPlanName} - product details accordion - ${val ? 'expand' : 'collapse'}`;
          } else if (this.$context.type === planTypes.ZOOM_PHONE) {
            buyInteraction = `${trackingPlanTypes['ZOOM_PHONE']} add-ons`;
            buySelection = `${this.trackingPlanName} - product details accordion - ${val ? 'expand' : 'collapse'}`;
          }
          this.$tracking.buyInteraction(buyInteraction, buySelection);
        } else {
          this.$tracking.buyInteraction(
            'product details accordion',
            `${this.trackingPlanName}${this.healthcareAvailable ? ` ${INDUSTRIES.HEALTHCARE}` : ''} - ${val ? 'expand' : 'collapse'}`,
          );
        }
      },
    },
    'form.billingCycle': {
      handler: debounce(function (val) {
        if (!this.isInitUpdateForm && this.isSchool) {
          this.$tracking.buyInteraction('subscription cycle', `${this.trackingPlanName} - ${val}`)
          return
        }

        !this.isInitUpdateForm && this.$tracking.buyInteraction(
          'billing cycle',
          `${this.trackingPlanName} - toggled billed ${val}`,
        );
        if (!this.isInitUpdateForm && this.healthcareAvailable) {
          const trackingPlanName = translateToEn(getTitleNameI18nKey(this.form?.category))
          this.$tracking.buyInteraction('subscription cycle', `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${val}`)
        }
      }, 500),
    },
    'form.selectedNumber': {
      handler: debounce(function (newLicense, oldLicense) {
        if (this.formPlan && !this.isInitUpdateForm) {
          // event tracking
          if (this.$context.is.edu) {
            let buyInteraction = 'number of licenses',
              buySelection = `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`;
            if (this.$context.type === planTypes.WEBINAR) {
              buyInteraction = `${trackingPlanTypes['WEBINAR']} add-ons`;
              buySelection = `${this.trackingPlanName} - number of licenses - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`;
            } else if (this.$context.type === planTypes.ZOOM_PHONE) {
              buyInteraction = `${trackingPlanTypes['ZOOM_PHONE']} add-ons`;
              buySelection = `${this.trackingPlanName} - number of licenses - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`;
            }
            this.$tracking.buyInteraction(buyInteraction, buySelection);
          } else {
            this.$tracking.buyInteraction(
              this.$context.is.edu ? 'number of licenses' : (this.isSchool ? 'number of users' : 'number of hosts'),
              `${this.trackingPlanName}${this.healthcareAvailable ? ` ${INDUSTRIES.HEALTHCARE}` : ''} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`);
          }
        }
      }, 500),
    },
    cartMeetingPlan: {
      deep: true,
      handler() {
        this.updateForm();
      },
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';


.opc-zmone {
  .main-icon {
    color: $theme-color;
  }

  .opc-zm-base-card__head-right__for_school--expand {
    padding-right: 32px;
    .opc-zm-base-card__name {
      align-items: baseline;
      .zm-icon-success {
        align-self: initial; // force override global styles(center)
      }
    }
  }

  .opc-zm-base-card__head-right__for_school--collapse {
    padding-right: 80px;
    .opc-zm-base-card__name {
      align-items: baseline;
      .zm-icon-success {
        align-self: initial; // force override global styles(center)
      }
    }
  }

  &__link.zm-button--link {
    margin-left: 5px;
    font-weight: 700 !important;
    color: $theme-color;
    padding: 0;
  }

  &__quantity-selector {
    margin-top: 12px;
    @include media(mobile) {
      margin-top: 12px;
    }
  }

  &__desc {
    padding-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: #00053d;
  }

  &__main {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #dfdfe4;
    @include media(mobile) {
      margin-top: 16px;
      padding-top: 16px;
    }
  }

  &__desc {
    position: relative;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #515079;
    padding: 0;
    margin: 0;

    &.is-warning {
      padding: 8px 12px 8px 40px;
      background: #FEF7D9;
      border-radius: 8px;

      &::before {
        content: '';
        background-image: url('../../../assets/Alert.svg');
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: calc(50% - 8px);
        left: 12px;
      }
    }
  }

  &__form-label {
    margin: 0;
    padding: 0;
    color: #00031F;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 27px;
    @include media(mobile) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__numbers-users-tooltip {
    margin-left: 4px;
  }

  &__lm-promotion {
    background: #DBF9F9;
    border-radius: 8px;
    padding: 8px 12px 8px 12px;
    margin-top: 16px;
    a {
      color: #0B5CFF;
    }
  }


  .opc-card-radio {
    margin-top: 8px;

    .opc-zmone__radio {
      width: 100%;

      .zm-radio__wrap {
        width: 100%;
      }
    }
  }

  .opc-card-radio &__radio {
    .zm-radio__label--inner {
      width: 100%;
      // min-height: 136px;
      padding: 16px;
    }

    .zm-radio__label {
      &.is-disabled {
        .opc-zmone__radio-title, .opc-zmone__radio-price, .opc-zmone__radio-price-unit {
          color: #9191A4 !important;
        }
      }
    }

    &-title {
      color: #00053D;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      margin: 0;
      display: flex;
      flex-wrap: wrap;

      .opc-price-save-count {
        margin-left: 4px;
      }
    }

    &-save-label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      color: #4a7d5c;
      min-width: 1px;
      min-height: 21px;
    }

    &-price {
      color: #00053D;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;

      &-unit {
        color: #666487;
        font-size: 12px;
        font-style: normal;
        font-weight: 450;
        line-height: 120%;
      }

      &-delete {
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        text-decoration-line: line-through;
        color: #515079;
      }
    }
  }

  .opc-campus-price-container {
    font-family: 'Almaden Sans';
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
    color: #515079;

    &__bill {
      color: #00053D;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;
    }
  }

  &__tip-lm-btn {
    display: block;
  }

  &__expand-lm-promo>span {
    color: #515079;
    @include darkTheme() {
      color: $dark-text-color2;
    }
  }
}

.opc-base-alert {
  &.zm-alert {
    background: #F7F7F8;
    margin-bottom: 24px !important;

    .zm-alert__icon {
      color: #666487 !important;
    }
  }

  &__message {
    font-family: Almaden Sans;
    font-size: 14px;
    font-weight: 450;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
  }
}
</style>
